import {IPaymentArticlesType, PaymentArticlesTypeResponseType} from "@/entity/finance/payment_articles/paymentArticlesType.types";

export default class PaymentArticlesType implements IPaymentArticlesType {
    id: number;
    name: string;
    constructor(data: PaymentArticlesTypeResponseType) {
        this.id = data.id;
        this.name = data.name;
    }
}